import { ListingSellerDraftModel, ListingSellerDraftModelConverter, ApiModel } from '@steelbuy/ts-shared';
import axios from '../../axios';

export const restartDraftListing = async (id: string) => {
    const modelConverter = new ListingSellerDraftModelConverter();
    const { data } = await axios.put<ApiModel<ListingSellerDraftModel>>(`/api/seller/listings/${id}/restart`);
    return modelConverter.toViewModel(data);
};
